import React from 'react'
import { Typography, Stack, Box } from '@mui/material'
import { Checkbox } from 'src/Libs/inputs/formik'
import CompanyAddress from './CompanyAddress'
import CustomerAddress from './CustomerAddress'
import DeviatingAddress from './DeviatingAddress'
import Installer from './Installer'
import Collapse from '@mui/material/Collapse'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Form, useFormikContext } from 'formik'
import { AddressFormData } from 'src/Libs/installation-statement/types'
import { PartnerSection } from './PartnerSection'

const useStyles = makeStyles()(theme => ({
  company: {
    flex: 1,
    backgroundColor: theme.palette.shades.shade04,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(4),
    marginTop: theme.spacing(4),
  },
  box: {
    [theme.breakpoints.up('md')]: {
      flex: 1,
    },
  },
}))

const DEVIATING_ADDRESS_CHECKBOX_NAME = 'deviatingAddressEnabled'

interface Props {
  deviatingAddressEnabled?: boolean
}

const AddressForm: React.VFC<Props> = () => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const { values } = useFormikContext<AddressFormData>()

  return (
    <Form>
      <Stack spacing={4} direction={{ xs: 'column', md: 'row' }}>
        <Box className={classes.box}>
          <Stack spacing={4}>
            <Typography variant="h4" sx={{ pb: 2 }}>
              {t('common.customer')}
            </Typography>
            <CustomerAddress />
            <Checkbox name={DEVIATING_ADDRESS_CHECKBOX_NAME} label={t('installation-statement.address.deviating-installation.checkbox-label')} />
            <Collapse in={values.deviatingAddressEnabled}>
              <Box>
                <Typography variant="h4" sx={{ pb: 2, mt: 2 }}>
                  {t('common.installation')}
                </Typography>
                <DeviatingAddress />
              </Box>
            </Collapse>
          </Stack>
        </Box>
        <Box className={classes.box}>
          <Stack spacing={4}>
            <Box className={classes.company}>
              <Typography variant="h4">{t('common.company')}</Typography>
              <Typography variant="subtitle2" pb={2}>
                {t('installation-statement.address.disabled-company-address-hint')}
              </Typography>
              <CompanyAddress />
              <Typography variant="h4" sx={{ pt: 4, pb: 2 }}>
                {t('common.installer')}
              </Typography>
              <Installer />

              <Typography variant="h5" sx={{ pt: 3, pb: 2 }}>
                {t('installation-statement.address.installation-for.title')}
              </Typography>
              <PartnerSection />
            </Box>
          </Stack>
        </Box>
      </Stack>
    </Form>
  )
}

export default AddressForm
